import angular from 'angular';
import { Change } from './u-change.directive';

export const ChangeModule = angular
  .module('app.directives.change', [])
  .directive('updChange', Change);
